import { Outlet } from "react-router-dom";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

export const Layout = () => (
  <div className="App">
    <Header />
    <main className="min-h-[60vh]">
      <Outlet />
    </main>
    <Footer />
  </div>
);
